export default "__VITE_ASSET__77e5b41a__"